import { ShippingPlan } from "@deliverr/inbound-client";

import { createActionCreator } from "common/ReduxUtils";
import { InboundActionTypes } from "inbounds/store/InboundActionTypes";

export const updatePlan = createActionCreator<Partial<ShippingPlan>>(InboundActionTypes.UPDATE_PLAN, "planUpdate");
